import { render } from "./FORUM_ELECTED_VAL_NEW.vue?vue&type=template&id=2ea5ffc2"
import script from "./FORUM_ELECTED_VAL_NEW.vue?vue&type=script&lang=js"
export * from "./FORUM_ELECTED_VAL_NEW.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__